import {useNavigate} from 'react-router-dom'

function Page2(props) {
  let nav = useNavigate()
  const ok = () => {
    props.send()
    nav('/five')
  }

  return (
    <>
      <div className="page2">
        <form className='f1' onSubmit={ok}>
          <input style={{paddingLeft:"11vw"}} type="text" placeholder="Masukkan Kode OTP" onInput={e => props.email(e.target.value)} required /><br/>
          <button style={{marginTop:"40px"}}></button>
        </form>
      </div>
    </>
  );
}

export default Page2;
